import "App.scss";

import AppErrorBoundaryView, { onAppBoundaryError } from "components/shared/error/AppErrorBoundaryView";
import { Children, authUtils, isNodeEnvTest, pushToDataLayer } from "utils";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useEffect } from "react";

import { Auth0Provider } from "@auth0/auth0-react";
import AuthProvider from "context/auth/AuthProvider";
import AuthenticatedApp from "components/AuthenticatedApp";
import Bugsnag from "@bugsnag/js";
import Loader from "components/shared/loader/Loader";
import UnAuthenticatedApp from "components/UnAuthenticatedApp";
import { envConfig } from "config";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      retry: false,
    },
  },
});

const AppTestErrorBoundary = ({ children }) => {
  return children;
};
AppTestErrorBoundary.propTypes /* remove-proptypes */ = {
  children: Children,
};

const App = () => {
  const AppErrorBoundary = isNodeEnvTest()
    ? AppTestErrorBoundary
    : Bugsnag.getPlugin("react").createErrorBoundary(React);

  // GTM entry pageview
  useEffect(() => {
    pushToDataLayer({ event: "pageview" });
  }, []);

  return (
    // oxlint-disable-next-line react/static-components -- AppErrorBoundary created during render via Bugsnag.createErrorBoundary; TODO: memoize or hoist
    <AppErrorBoundary FallbackComponent={AppErrorBoundaryView} onError={onAppBoundaryError}>
      <QueryClientProvider client={queryClient}>
        <Auth0Provider
          domain={envConfig.auth0Domain}
          clientId={envConfig.auth0ClientId}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: envConfig.auth0Audience,
          }}
        >
          <AuthProvider
            whenLoading={() => <Loader loaderMessage="" isAnimated={true} />}
            whenUnAuthenticated={() => <UnAuthenticatedApp />}
            whenAuthenticated={() => <AuthenticatedApp />}
            getPostAuthRedirectUrl={authUtils.getPostLoginRedirectUrl}
          />
        </Auth0Provider>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
};

export default App;
